export enum TcpResult {
  Success = 0
}
